import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProbotComponent } from './simple-icons-probot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProbotComponent ],
    exports:      [ SimpleIconsProbotComponent ],
    bootstrap:    []
})
export class SimpleIconsProbotModule {}
